module.exports = __webpack_public_path__ + "img/video.3b3e1ebe.jpg";